/* Skeleton.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import React from 'react';
import { HeaderSkeleton, Stripe } from '../../HomePageCommonSkeleton';
import { Card } from './ProminentSectionInfo';
const _5 = "@media (min-width:48rem){._19wgpxbi{gap:var(--ds-space-200,1pc)}}";
const _4 = "._zulph461{gap:var(--ds-space-050)}";
const _3 = "._otyrhiv4{margin-bottom:var(--ds-space-400)}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _otyrhiv4 _zulph461 _19wgpxbi", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const ProminentSectionInfoSkeleton = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Show, {
  above: "sm"
}, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Stripe, {
  width: "224px",
  borderRadius: "10px"
}), /*#__PURE__*/React.createElement(Stripe, {
  width: "194px",
  borderRadius: "10px"
})), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Stripe, {
  height: "14px"
}), /*#__PURE__*/React.createElement(Stripe, {
  height: "14px"
}), /*#__PURE__*/React.createElement(Stripe, {
  height: "14px",
  width: "182px"
})), /*#__PURE__*/React.createElement(Stripe, {
  width: "160px",
  height: "10px",
  borderRadius: "var(--ds-border-radius-100, 4px)"
}))), /*#__PURE__*/React.createElement(Hide, {
  above: "sm"
}, /*#__PURE__*/React.createElement(HeaderSkeleton, null)));